/* unplugin-vue-components disabled */
import {Rest} from 'utils'
import {DropdownCalendar} from 'components/filters'

export default {
  components: {
    DropdownCalendar
  },
  props: {
    api: {
      type: String,
      required: true
    }
  },
  data() {
    const to = new Date()
    const from = new Date()
    from.setDate(to.getDate() - 30)
    
    return {
      loading: true,
      range: [from, to],
      rest: new Rest(),
      stats: undefined,
    }
  },
  computed: {
    valid_range(){
      return (this.range.length === 2 && this.range.every(d => !!d))
    },
    date(){
      if (!this.valid_range) return 'Select a date range'
      const from = $utils.format.date(this.range[0])
      const to = $utils.format.date(this.range[1])
      return `${from} - ${to}`
    },
  },
  watch: {
    range: {
      async handler() {
        if (!this.valid_range) return
      
        this.stats = await this.getStats()
      },
      deep: true
    }
  },
  async mounted() {
    this.loading = true
    try {
      this.stats = await this.getStats()
      
    } catch (error) {
      // 
    }
    this.loading = false
  },
  methods: {
    getStats() {   
      const [from, to] =  $utils.format.normalizeDateRange(this.range)
      return this.rest.get(this.api, {from,to})
    }
  }
}
